import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setHeadings, setselectedTab } from "../Store/B2bslice";
import {
  BsBank,
  BsBank2,
  BsBusFrontFill,
  BsListUl,
  BsPeople,
  BsQrCode,
} from "react-icons/bs";
import {
  FaMoneyBill,
  FaMoneyCheck,
  FaCertificate,
  FaRupeeSign,
} from "react-icons/fa";
import {
  MdAccountBalance,
  MdAccountBalanceWallet,
  MdAdd,
  MdLeaderboard,
  MdOutlineFlight,
  MdOutlinePayment,
  MdOutlinePayments,
  MdOutlineTravelExplore,
  MdWallet,
} from "react-icons/md";
import { TbFileInvoice, TbRecharging, TbReportMoney } from "react-icons/tb";
import { IoCashOutline, IoDocumentTextSharp } from "react-icons/io5";
import { BiRun, BiSolidHotel, BiTransferAlt } from "react-icons/bi";
import { FaMoneyBillTransfer, FaRegAddressCard } from "react-icons/fa6";
import { FcTodoList } from "react-icons/fc";
import { saveAs } from "file-saver";
import {
  AiOutlineHome,
  AiOutlineHistory,
  AiOutlineWallet,
} from "react-icons/ai";
import { Tooltip } from "antd";
import { getLocalStorageItem } from "../Utils";
import axios from "axios";
import { APIURL } from "../ApiServices/Axios";
import { Globalendpoints } from "../ApiServices/global";
import { ThemeColor } from "../Theme/theme";
import { RiBatteryChargeLine } from "react-icons/ri";
import { CreditCardOutlined } from "@ant-design/icons";
import {
  GenerateLeadGenerationLink,
  getAEPSiciciUpdateStatus,
} from "../ApiServices/Apifun";

// export const Menuitems = ({
//   setShowModalForUpdate,
//   showModalForUpdate,
//   setPendingRoute,
//   setShowModalForEkycUpdate,
//   showModalForEkycUpdate,
//   setExpired_date,
// }) => {
export const Menuitems = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);

  const checkAEPSiciciUpdateStatus = async (e, route, state) => {
    try {
      const res = await getAEPSiciciUpdateStatus();

      if (res.status && res.data.pinwallet_onboard_status == 0) {
        e.preventDefault();
        setExpired_date(res.data.expired_date);
        setPendingRoute({
          route,
          state,
        });

        setShowModalForUpdate(true);
        return;
      } else if (res.status && res.data.pinwallet_ekyc_status == 0) {
        setExpired_date(res.data.expired_date);
        e.preventDefault(); // navigation stop

        setPendingRoute({
          route,
          state,
        });

        setShowModalForEkycUpdate(true);
        return;
      }
    } catch (err) {
      console.log(err);
      e.preventDefault();
      return;
    }
  };

  const checkStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    } else {
      return to;
    }
  };
  const checkWithdrawalStatus = (to) => {
    if (!profiledetail.aeps_onboard) {
      return "/banking/aeps-onboard";
    } else if (!profiledetail.ekyc_status) {
      return "/banking/aeps-ekyc";
    } else if (!profiledetail.twofa_status) {
      return "/banking/aeps";
    }
    //  else if (withdrawalTime === 0) {
    //   return "/banking/aeps";
    // }
    else {
      return to;
    }
  };
  const checkYesBankStatus = (to) => {
    if (
      profiledetail.bank2_aeps_memberkyc == "3" ||
      profiledetail.bank2_aeps_memberkyc == "2" ||
      profiledetail.bank2_aeps_memberkyc == "0"
    ) {
      return "/banking/aepsyes-memberkyc";
    } else if (!profiledetail.bank2_aeps_onboard) {
      return "/banking/aepsyes-onboard";
    } else {
      return to;
    }
  };
  const checkCredoStatus = () => {
    if (!profiledetail.credo_aeps_onboard) {
      return "/banking/aeps2-onboard";
    } else if (!profiledetail.credo_aeps_status) {
      return "/banking/waiting";
    } else if (
      profiledetail.credo_aeps_onboard &&
      profiledetail.credo_aeps_status
    ) {
      return "/banking/aeps2-2fa";
    }
  };

  const checkDigiStatus = () => {
    if (
      profiledetail.digio_kyc === "0" ||
      profiledetail.digio_kyc === "2" ||
      profiledetail.digio_kyc === "3"
    ) {
      return true;
    }
  };
  const list = [
    {
      key: "1",
      icon: <AiOutlineHome />,
      label: (
        <NavLink to={checkDigiStatus() ? "/kycStatus" : "/dashboard"}>
          <p>Dashboard</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("1"));
        dispatch(setHeadings("Dashboard"));
      },
    },

    // {
    //   key: "2",
    //   icon: <TbRecharging />,
    //   label: <p>Recharge</p>,
    //   children: [
    //     {
    //       key: "2.1",
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus()
    //               ? "/kycStatus"
    //               : memberServices.includes("1")
    //                 ? "/recharge"
    //                 : "/not-available"
    //           }
    //         >
    //           Recharge
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: "2.2",
    //       label: (
    //         <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/recharge"}>
    //           Report
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   key: "201",
    //   icon: <FaMoneyBill />,
    //   label: <p>BBPS</p>,
    //   children: [
    //     {
    //       key: "201.1",
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus()
    //               ? "/kycStatus"
    //               : memberServices.includes("1")
    //                 ? "/bbps"
    //                 : "/not-available"
    //           }
    //         >
    //           BBPS
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: "201.2",
    //       label: (
    //         <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/bbps"}>
    //           Report
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
    {
      key: "2012",
      icon: <RiBatteryChargeLine />,
      label: <p>Recharge </p>,
      children: [
        {
          key: "2012.1",
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("201")
                    ? "/recharge/v1"
                    : "/not-available"
              }
            >
              <p>Recharge </p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("2012.1"));
            dispatch(setHeadings("Recharge & Bill Payment"));
          },
        },
        {
          key: "2012.2",
          label: (
            <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/recharge"}>
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("2012.2"));
            dispatch(setHeadings("Recharge  Report"));
          },
        },
      ],
    },
    {
      key: "202",
      icon: <FaMoneyBillTransfer />,
      label: <p>BBPS </p>,
      children: [
        {
          key: "202.1",
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("202")
                    ? "/bbps/v1"
                    : "/not-available"
              }
            >
              <p>BBPS </p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("202.1"));
            dispatch(setHeadings("BBPS V1"));
          },
        },
        {
          key: "202.2",
          label: (
            <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/bbps2"}>
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("202.2"));
            dispatch(setHeadings("BBPS  Report"));
          },
        },
      ],
    },
    {
      key: "105",
      icon: <MdAccountBalance />,
      label: <p> Lead Generation</p>,
      children: [
        {
          key: "105.1",
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("207")
                    ? "/lead-generation"
                    : "/not-available"
              }
            >
              <p>Service</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("105.1"));
            dispatch(setHeadings("Loan & Credit Card Lead"));
          },
        },
        {
          key: "105.2",
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : "/Report/lead-generation-report"
              }
            >
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("105.2"));
            dispatch(setHeadings("Lead Generation Report"));
          },
        },
      ],
    },
    // memberServices.includes("205") && {
    //   key: "205",
    //   icon: <CreditCardOutlined />,
    //   label: <p>Credit Card Bill</p>,
    //   children: [
    //     {
    //       key: "205.1",
    //       label: (
    //         <NavLink
    //           to={checkDigiStatus() ? "/kycStatus" : "/creditCardPayments"}
    //         >
    //           <p>Service</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("205.1"));
    //         dispatch(setHeadings("CC Bill Payment"));
    //       },
    //     },
    //     {
    //       key: "205.2",
    //       label: (
    //         <NavLink
    //           to={checkDigiStatus() ? "/kycStatus" : "/Report/creditCardBill"}
    //         >
    //           <p>Report</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("205.2"));
    //         dispatch(setHeadings("Credit Card Bill Report"));
    //       },
    //     },
    //   ],
    // },
    // {
    //   key: "1005",
    //   icon: <FaMoneyBillTransfer />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("305")
    //             ? "/bbps3"
    //             : "/not-available"
    //       }
    //     >
    //       <p>BBPS 3</p>
    //     </NavLink>
    //   ),
    //   // children: [
    //   //   {
    //   //     key: "17.2",
    //   //     icon: <FaRupeeSign />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //           checkDigiStatus()
    //   //             ? "/kycStatus"
    //   //             : memberServices.includes("20")
    //   //             ? checkYesBankStatus("/banking/aepsyes-cash-withdrawl")
    //   //             : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-cash-withdrawl" }}
    //   //       >
    //   //         <p>Cash Withdrawl</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.2"));
    //   //       dispatch(setHeadings("Cash Withdrawl"));
    //   //     },
    //   //   },
    //   //   {
    //   //     key: "17.4",
    //   //     icon: <IoDocumentTextSharp />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //           checkDigiStatus()
    //   //             ? "/kycStatus"
    //   //             : memberServices.includes("20")
    //   //             ? checkYesBankStatus("/banking/aepsyes-miniStatement")
    //   //             : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-miniStatement"}}
    //   //       >
    //   //         <p>Mini Statement</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.4"));
    //   //       dispatch(setHeadings("Mini statement"));
    //   //     },
    //   //   },
    //   //   {
    //   //     key: "17.5",
    //   //     icon: <MdAccountBalance />,
    //   //     label: (
    //   //       <NavLink
    //   //         to={
    //   //         checkDigiStatus()
    //   //         ? "/kycStatus"
    //   //         : memberServices.includes("20")
    //   //         ? checkYesBankStatus("/banking/aepsyes-balanceEnquiry")
    //   //         : "/not-available"
    //   //         }
    //   //         state={{ from: "/banking/aepsyes-balanceEnquiry"}}
    //   //       >
    //   //         <p>Balance Enquiry</p>
    //   //       </NavLink>
    //   //     ),
    //   //     onClick: () => {
    //   //       dispatch(setselectedTab("17.5"));
    //   //       dispatch(setHeadings("Balance Enquiry"));
    //   //     },
    //   //   },
    //   // ],
    // },
    // {
    //   key: "171",
    //   icon: <FaCertificate />,
    //   label: (
    //     // <NavLink
    //     //   to={
    //     //     checkDigiStatus()
    //     //       ? "/kycStatus"
    //     //       : memberServices.includes("20")
    //     //       ? checkYesBankStatus("/banking/aeps-yesbank")
    //     //       : "/not-available"
    //     //   }
    //     // >
    //     <p>BC Certificate</p>
    //     // </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("171"));
    //     axios
    //       .get(APIURL + "Api/V1/Member/yesBankCertificateDownload", {
    //         responseType: "blob",
    //         headers: {
    //           "Content-Type": "application/pdf",
    //           // Range: "bytes=0-999999",
    //           Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
    //         },
    //       })
    //       .then((res) => {
    //         saveAs(res.data, "BC certificate.pdf");
    //       })
    //       .catch((err) => console.log(err));
    //   },
    // },
    // {
    //   key: "117",
    //   icon: <FaMoneyBill />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("25")
    //             ? checkCredoStatus()
    //             : "/not-available"
    //       }
    //     >
    //       <p>AEPS-2</p>
    //     </NavLink>
    //   ),
    // },

    // {
    //   key: "1123",
    //   icon: <FaMoneyBill />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("301")
    //             ? checkAeps3Status("/banking/aeps3/services")
    //             : "/not-available"
    //       }
    //     >
    //       <p>AEPS-3</p>
    //     </NavLink>
    //   ),
    // },
    // {
    //   key: "1123",
    //   icon: <MdAccountBalanceWallet />,
    //   label: (
    //     <NavLink>
    //       <p>AEPS-3</p>
    //     </NavLink>
    //   ),
    //   children: [
    //     {
    //       key: "1123.1",
    //       icon: <FaRupeeSign />,
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus()
    //               ? "/kycStatus"
    //               : memberServices.includes("206")
    //                 ? "/banking/aeps3-merchant-onboard"
    //                 : "/not-available"
    //           }
    //         >
    //           <p>Aeps-3 Service</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("1123.1"));
    //         dispatch(setHeadings("Aeps-3 Service"));
    //       },
    //     },
    //     {
    //       key: "1123.2",
    //       icon: <MdWallet />,
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus() ? "/kycStatus" : "/Report/aeps_wallet_report"
    //           }
    //         >
    //           <p>Aeps Wallet</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("1123.2"));
    //         dispatch(setHeadings("Aeps Wallet Report"));
    //       },
    //     },
    //     {
    //       key: "1123.3",
    //       icon: <MdOutlinePayment />,
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus()
    //               ? "/kycStatus"
    //               : memberServices.includes("206")
    //                 ? "/aeps3/payout/verification"
    //                 : "/not-available"
    //           }
    //         >
    //           <p>Payout</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("1123.3"));
    //         dispatch(setHeadings("Payout "));
    //       },
    //     },
    //     {
    //       key: "1123.4",
    //       icon: <TbReportMoney />,
    //       label: (
    //         <NavLink
    //           to={checkDigiStatus() ? "/kycStatus" : "/aeps3/payout/report"}
    //         >
    //           <p>Payout Report</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("1123.4"));
    //         dispatch(setHeadings("Payout Report"));
    //       },
    //     },
    //     {
    //       key: "1123.5",
    //       icon: <TbReportMoney />,
    //       label: (
    //         <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/aeps3"}>
    //           <p>Aeps-3 Report</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("1123.5"));
    //         dispatch(setHeadings("Aeps-3 Report"));
    //       },
    //     },
    //   ],
    // },
    {
      key: "3",
      icon: <BsBank />,
      label: (
        <NavLink>
          <p>AEPS</p>
        </NavLink>
      ),
      children: [
        {
          key: "3.1",
          icon: <IoCashOutline />,
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkWithdrawalStatus("/banking/aeps-cash-deposit")
                    : "/not-available"
              }
              state={{
                from: "/banking/aeps-cash-deposit",
                type: "cash_deposit",
              }}
            >
              <p className="text-xs">Cash Deposit</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.1"));
            dispatch(setHeadings("Cash Deposit"));
          },
        },

        // Cash Deposit Report
        {
          key: "3.1.1",
          // icon: <TbReportMoney />,
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-deposit"}
            >
              <p className="text-xs">Cash Deposit Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.1.1"));
            dispatch(setHeadings("Cash Deposit Report"));
          },
        },

        {
          key: "3.2",
          icon: <FaRupeeSign />,
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkWithdrawalStatus("/banking/aeps-cash-withdrawl")
                    : "/not-available"
              }
              state={{ from: "/banking/aeps-cash-withdrawl", type: "aeps" }}
            >
              <p className="text-xs">Cash Withdrawl</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.2"));
            dispatch(setHeadings("Cash Withdrawl"));
          },
        },

        // Cash Withdrawal Report
        {
          key: "3.2.1",
          // icon: <TbReportMoney />,
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-withdrawl"}
            >
              <p className="text-xs">Cash Withdrawl Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.2.1"));
            dispatch(setHeadings("Cash Withdrawl Report"));
          },
        },

        {
          key: "3.3",
          icon: <FaRupeeSign />,
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkWithdrawalStatus("/banking/aeps-aadharpay")
                    : "/not-available"
              }
              state={{ from: "/banking/aeps-aadharpay", type: "aadhar_pay" }}
            >
              <p className="text-xs">Aadhar Pay</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.3"));
            dispatch(setHeadings("Aadhar Pay"));
          },
        },

        // Aadhar Pay Report
        {
          key: "3.3.1",
          // icon: <TbReportMoney />,
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/aadharpay"}
            >
              <p className="text-xs">Aadhar Pay Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.3.1"));
            dispatch(setHeadings("Aadhar Pay Report"));
          },
        },

        {
          key: "3.4",
          icon: <IoDocumentTextSharp />,
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkStatus("/banking/aeps-miniStatement")
                    : "/not-available"
              }
              state={{ from: "/banking/aeps-miniStatement", type: "aeps" }}
            >
              <p className="text-xs">Mini Statement</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.4"));
            dispatch(setHeadings("Mini Statement"));
          },
        },

        // Mini Statement Report
        {
          key: "3.4.1",
          // icon: <TbReportMoney />,
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/Mini-statement"}
            >
              <p className="text-xs">Mini Statement Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.4.1"));
            dispatch(setHeadings("Mini Statement Report"));
          },
        },

        {
          key: "3.5",
          icon: <MdAccountBalance />,
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("8")
                    ? checkStatus("/banking/aeps-balanceEnquiry")
                    : "/not-available"
              }
              state={{ from: "/banking/aeps-balanceEnquiry", type: "aeps" }}
            >
              <p className="text-xs">Balance Enquiry</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.5"));
            dispatch(setHeadings("Balance Enquiry"));
          },
        },

        // Balance Enquiry Report
        {
          key: "3.5.1",
          // icon: <TbReportMoney />,
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/balance-enquirey"}
            >
              <p className="text-xs">Balance Enquiry Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("3.5.1"));
            dispatch(setHeadings("Balance Enquiry Report"));
          },
        },
      ],
    },
    // {
    //   key: "17",
    //   icon: <BsBank2 />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("20")
    //             ? checkYesBankStatus("/banking/aeps-yesbank")
    //             : "/not-available"
    //       }
    //     >
    //       <p>AEPS Bank-2</p>
    //     </NavLink>
    //   ),
    // children: [
    //   {
    //     key: "17.2",
    //     icon: <FaRupeeSign />,
    //     label: (
    //       <NavLink
    //         to={
    //           checkDigiStatus()
    //             ? "/kycStatus"
    //             : memberServices.includes("20")
    //             ? checkYesBankStatus("/banking/aepsyes-cash-withdrawl")
    //             : "/not-available"
    //         }
    //         state={{ from: "/banking/aepsyes-cash-withdrawl" }}
    //       >
    //         <p>Cash Withdrawl</p>
    //       </NavLink>
    //     ),
    //     onClick: () => {
    //       dispatch(setselectedTab("17.2"));
    //       dispatch(setHeadings("Cash Withdrawl"));
    //     },
    //   },
    //   {
    //     key: "17.4",
    //     icon: <IoDocumentTextSharp />,
    //     label: (
    //       <NavLink
    //         to={
    //           checkDigiStatus()
    //             ? "/kycStatus"
    //             : memberServices.includes("20")
    //             ? checkYesBankStatus("/banking/aepsyes-miniStatement")
    //             : "/not-available"
    //         }
    //         state={{ from: "/banking/aepsyes-miniStatement"}}
    //       >
    //         <p>Mini Statement</p>
    //       </NavLink>
    //     ),
    //     onClick: () => {
    //       dispatch(setselectedTab("17.4"));
    //       dispatch(setHeadings("Mini statement"));
    //     },
    //   },
    //   {
    //     key: "17.5",
    //     icon: <MdAccountBalance />,
    //     label: (
    //       <NavLink
    //         to={
    //         checkDigiStatus()
    //         ? "/kycStatus"
    //         : memberServices.includes("20")
    //         ? checkYesBankStatus("/banking/aepsyes-balanceEnquiry")
    //         : "/not-available"
    //         }
    //         state={{ from: "/banking/aepsyes-balanceEnquiry"}}
    //       >
    //         <p>Balance Enquiry</p>
    //       </NavLink>
    //     ),
    //     onClick: () => {
    //       dispatch(setselectedTab("17.5"));
    //       dispatch(setHeadings("Balance Enquiry"));
    //     },
    //   },
    // ],
    // },
    // {
    //   key: "13",
    //   icon: <BsQrCode />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("18")
    //           ? "/upi"
    //           : "/not-available"
    //       }
    //     >
    //       <p>UPI</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("13"));
    //     dispatch(setHeadings("UPI"));
    //   },
    // },
    // {
    //   key: "22",
    //   icon: <BsQrCode />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("21")
    //           ? "/upi-dmt"
    //           : "/not-available"
    //       }
    //     >
    //       <p>UPI DMT</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("13"));
    //     dispatch(setHeadings("UPI"));
    //   },
    // },
    {
      key: "10",
      icon: <FaMoneyCheck />,
      label: <p>Fund Request</p>,
      children: [
        {
          key: "10.1",
          label: (
            <NavLink to="/fundRequest">
              <p>Service</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("10.1"));
            dispatch(setHeadings("Fund Request"));
          },
        },
        {
          key: "10.2",
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/fund-request"}
            >
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("10.2"));
            dispatch(setHeadings("Fund Request Report"));
          },
        },
      ],
    },
    // {
    //   key: "7",
    //   icon: <IoDocumentTextSharp />,
    //   label: <p>UTI</p>,
    //   children: [
    //     {
    //       key: "7.1",
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus()
    //               ? "/kycStatus"
    //               : memberServices.includes("16")
    //                 ? "/uti"
    //                 : "/not-available"
    //           }
    //         >
    //           <p>Service</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("7.1"));
    //         dispatch(setHeadings("UTI"));
    //       },
    //     },
    //     {
    //       key: "7.2",
    //       label: (
    //         <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/uti"}>
    //           <p>Report</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("7.2"));
    //         dispatch(setHeadings("UTI Report"));
    //       },
    //     },
    //   ],
    // },
    {
      key: "16",
      icon: <FaRegAddressCard />,
      label: <p>Pan Services</p>,
      children: [
        {
          key: "16.1",
          label: (
            <NavLink to={"/panServices"}>
              <p> Service</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("16.1"));
            dispatch(setHeadings("Pan Services"));
          },
        },
        {
          key: "16.2",
          label: (
            <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/nsdl"}>
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("16.2"));
            dispatch(setHeadings("Pan Services Report"));
          },
        },
      ],
    },

    // {
    //   key: "4",
    //   icon: <BiTransferAlt />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : profiledetail.dmt_kyc === "1" && memberServices.includes("4")
    //             ? "/dmt/remitters"
    //             : profiledetail.dmt_kyc !== "1" && memberServices.includes("4")
    //               ? "/dmt/submitKyc"
    //               : "/not-available"
    //       }
    //     >
    //       <p>DMT</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("4"));
    //     dispatch(setHeadings("DMT"));
    //   },
    // },

    {
      key: "24",
      icon: <BiTransferAlt />,
      label: <p>Money Transfer</p>,
      children: [
        {
          key: "24.1",
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("4")
                    ? "/dmt3/remitters"
                    : "/not-available"
              }
            >
              <p>Service</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("24.1"));
            dispatch(setHeadings("Money Transfer"));
          },
        },
        {
          key: "24.2",
          label: (
            <NavLink
              to={checkDigiStatus() ? "/kycStatus" : "/Report/money-transfer"}
            >
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("24.2"));
            dispatch(setHeadings("Money Transfer Report"));
          },
        },
      ],
    },
    // {
    //   key: "199",
    //   icon: <BiTransferAlt />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("203")
    //             ? "/dmt2/remitters"
    //             : "/not-available"
    //       }
    //     >
    //       <p>DMT 2</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("199"));
    //     dispatch(setHeadings("DMT"));
    //   },
    // },
    {
      key: "5",
      icon: <MdOutlinePayments />,
      label: <p>Payout</p>,
      children: [
        {
          key: "5.1",
          label: (
            <NavLink
              to={
                checkDigiStatus()
                  ? "/kycStatus"
                  : memberServices.includes("5")
                    ? "/payout/verification"
                    : "/not-available"
              }
            >
              <p>Service</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("5.1"));
            dispatch(setHeadings("Payout"));
          },
        },
        {
          key: "5.2",
          label: (
            <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/payout"}>
              <p>Report</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("5.2"));
            dispatch(setHeadings("Payout Report"));
          },
        },
      ],
    },
    // {
    //   key: "14",
    //   icon: <BiRun />,
    //   label: <p>Express Payout</p>,
    //   children: [
    //     {
    //       key: "14.1",
    //       label: (
    //         <NavLink
    //           to={
    //             checkDigiStatus()
    //               ? "/kycStatus"
    //               : memberServices.includes("9")
    //                 ? "/express-payout"
    //                 : "/not-available"
    //           }
    //         >
    //           <p>Service</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("14.1"));
    //         dispatch(setHeadings("Express Payout"));
    //       },
    //     },
    //     {
    //       key: "14.2",
    //       label: (
    //         <NavLink
    //           to={checkDigiStatus() ? "/kycStatus" : "/Report/xpressPayout"}
    //         >
    //           <p>Report</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("14.2"));
    //         dispatch(setHeadings("Express Payout Report"));
    //       },
    //     },
    //   ],
    // },
    // {
    //   key: "5",
    //   icon: <MdOutlinePayments />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("5")
    //             ? "/payout/verification"
    //             : "/not-available"
    //       }
    //     >
    //       <p>PayOut</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("5"));
    //     dispatch(setHeadings("Payout"));
    //   },
    // },
    // {
    //   key: "14",
    //   icon: <BiRun />,
    //   label: (
    //     <NavLink
    //       to={
    //         checkDigiStatus()
    //           ? "/kycStatus"
    //           : memberServices.includes("9")
    //             ? "/express-payout"
    //             : "/not-available"
    //       }
    //     >
    //       <p>Express Payout</p>
    //     </NavLink>
    //   ),
    //   onClick: () => {
    //     dispatch(setselectedTab("14"));
    //     dispatch(setHeadings("Payout"));
    //   },
    // },
    // {
    //   key: "6",
    //   icon: <MdOutlineTravelExplore />,
    //   label: (
    //     <NavLink>
    //       <p>Travel</p>
    //     </NavLink>
    //   ),
    //   children: [
    //     {
    //       key: "6.1",
    //       icon: <MdOutlineFlight />,
    //       label: (
    //         <NavLink
    //           to={memberServices.includes("14") ? "/flights" : "/coming-soon"}
    //         >
    //           <p>Flight</p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("6.1"));
    //         dispatch(setHeadings("Flight ticket"));
    //       },
    //     },
    //     {
    //       key: "6.2",
    //       icon: <BsBusFrontFill />,
    //       label: (
    //         <NavLink
    //           to={memberServices.includes("13") ? "/bus" : "/coming-soon"}
    //         >
    //           <p>Bus </p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("6.2"));
    //         dispatch(setHeadings("Bus ticket"));
    //       },
    //     },
    //     {
    //       key: "6.3",
    //       icon: <BiSolidHotel />,
    //       label: (
    //         <NavLink
    //           to={memberServices.includes("12") ? "/hotel" : "/coming-soon"}
    //         >
    //           <p>Hotel </p>
    //         </NavLink>
    //       ),
    //       onClick: () => {
    //         dispatch(setselectedTab("6.3"));
    //         dispatch(setHeadings("Hotel Booking"));
    //       },
    //     },
    //   ],
    // },
    {
      key: "15",
      icon: <BsPeople />,
      label: (
        <NavLink to={checkDigiStatus() ? "/kycStatus" : "/memberList"}>
          <p>Members</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("15"));
        dispatch(setHeadings("Member List"));
      },
    },
    {
      key: "44",
      icon: <FaRupeeSign />,
      label: (
        <NavLink to={checkDigiStatus() ? "/kycStatus" : "/give-topup"}>
          <p>Give TopUp</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("44"));
      },
    },
    {
      key: "12",
      icon: <AiOutlineWallet />,
      label: (
        <NavLink to={"/Report/wallet"}>
          <p>Wallet</p>
        </NavLink>
      ),
      onClick: () => {
        dispatch(setselectedTab("12"));
        dispatch(setHeadings("Wallet Report"));
      },
    },
    {
      key: "11",
      icon: <AiOutlineHistory />,
      label: <p>Reports</p>,
      children: [
        // {
        //   key: "11.57",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-transaction"}
        //     >
        //       <Tooltip title="CashWithdrawl Report">
        //         <p>Aeps-2 Report</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.57"));
        //     dispatch(setHeadings("Credo Aeps Transaction"));
        //   },
        // },
        // {
        //   key: "11.57",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-transaction"}
        //     >
        //       <Tooltip title="CashWithdrawl Report">
        //         <p>Aeps-2 Report</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.57"));
        //     dispatch(setHeadings("Credo Aeps Transaction"));
        //   },
        // },
        // {
        //   key: "11.19",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/dmt2"}>
        //       <p>Dmt 2</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.19"));
        //     dispatch(setHeadings("DMT 2 Report"));
        //   },
        // },
        // {
        //   key: "11.01",
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-deposit"}
        //     >
        //       <Tooltip title="Cash Deposit Report">
        //         <p>Cash Deposit</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.01"));
        //     dispatch(setHeadings("Cash Deposit Report"));
        //   },
        // },
        // {
        //   key: "11.1",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-withdrawl"}
        //     >
        //       <Tooltip title="CashWithdrawl Report">
        //         <p>CashWithdrawl</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.1"));
        //     dispatch(setHeadings("Cash Withdrawl Report"));
        //   },
        // },
        // {
        //   key: "11.1000",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/cash-deposit"}
        //     >
        //       <Tooltip title="CashDeposit Report">
        //         <p>Cash Deposit</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.1000"));
        //   },
        // },
        // {
        //   key: "11.2",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/Mini-statement"}
        //     >
        //       <Tooltip title="MiniStatement Report">
        //         <p>MiniStatement</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.2"));
        //     dispatch(setHeadings("Mini Statement Report"));
        //   },
        // },
        // {
        //   key: "11.10",
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/fund-request"}
        //     >
        //       <p>Fund Request</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.10"));
        //     dispatch(setHeadings("Fund Request Report"));
        //   },
        // },
        // {
        //   key: "11.14",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/yesBank"}>
        //       <p>Yes Bank AEPS</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.14"));
        //     dispatch(setHeadings("Yes Bank AEPS"));
        //   },
        // },
        // {
        //   key: "11.3",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/aadharpay"}
        //     >
        //       <Tooltip title="MiniStatement Report">
        //         <p>Aadhar Pay</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.3"));
        //     dispatch(setHeadings("Aadhar Pay Report"));
        //   },
        // },
        // {
        //   key: "11.12",
        //   // icon: <MdAccountBalance />,
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/balance-enquirey"}
        //     >
        //       <Tooltip title="Balance Enquirey">
        //         <p>Balance Enquirey</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.12"));
        //     dispatch(setHeadings("Balance Enquirey Report"));
        //   },
        // },
        // {
        //   key: "11.5",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/recharge"}>
        //       <p>Recharge</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.5"));
        //     dispatch(setHeadings("Recharge Report"));
        //   },
        // },

        // {
        //   key: "11.4",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/payout"}>
        //       <p>Payout</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.4"));
        //     dispatch(setHeadings("Payout Report"));
        //   },
        // },

        // {
        //   key: "11.11",
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/xpressPayout"}
        //     >
        //       <p>Express DMT</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.11"));
        //   },
        // },
        // {
        //   key: "11.9",
        //   label: (
        //     <NavLink
        //       to={
        //         checkDigiStatus()
        //           ? "/kycStatus"
        //           : "/Report/lead-generation-report"
        //       }
        //     >
        //       <Tooltip title="Lead Generation Report">
        //         <p>Lead Generation</p>
        //       </Tooltip>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.9"));
        //     dispatch(setHeadings("Lead Generation Report"));
        //   },
        // },
        // {
        //   key: "11.6",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/bbps"}>
        //       <p>BBPS</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.6"));
        //     dispatch(setHeadings("BBPS Report"));
        //   },
        // },
        // {
        //   key: "11.61",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/bbps"}>
        //       <p>BBPS</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.61"));
        //     dispatch(setHeadings("BBPS  Report"));
        //   },
        // },
        // {
        //   key: "11.7",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/dmt"}>
        //       <p>Dmt</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.7"));
        //     dispatch(setHeadings("DMT Report"));
        //   },
        // },
        // {
        //   key: "11.19",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/dmt2"}>
        //       <p>Dmt 2</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.19"));
        //     dispatch(setHeadings("DMT 2 Report"));
        //   },
        // },
        // {
        //   key: "11.11",
        //   label: (
        //     <NavLink
        //       to={checkDigiStatus() ? "/kycStatus" : "/Report/xpressPayout"}
        //     >
        //       <p>XpressPayout</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.11"));
        //   },
        // },
        // {
        //   key: "11.6",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/bbps"}>
        //       <p>BBPS</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.6"));
        //     dispatch(setHeadings("BBPS Report"));
        //   },
        // },

        // {
        //   key: "11.81",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/bbps3"}>
        //       <p>BBPS3</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     handleRemoveIframeItems();
        //     dispatch(setselectedTab("11.81"));
        //     dispatch(setHeadings("BBPS3 Report"));
        //   },
        // },
        // {
        //   key: "11.7",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/dmt"}>
        //       <p>Dmt</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.7"));
        //     dispatch(setHeadings("DMT Report"));
        //   },
        // },
        {
          key: "11.17",
          label: (
            <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/m-atm"}>
              <p>M-ATM</p>
            </NavLink>
          ),
          onClick: () => {
            dispatch(setselectedTab("11.17"));
            dispatch(setHeadings("M ATM Report"));
          },
        },
        // {
        //   key: "11.8",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/uti"}>
        //       <p>Uti</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.8"));
        //     dispatch(setHeadings("Uti Report"));
        //   },
        // },

        // {
        //   key: "11.15",
        //   label: (
        //     <NavLink to={checkDigiStatus() ? "/kycStatus" : "/Report/upi-dmt"}>
        //       <p>Upi DMT</p>
        //     </NavLink>
        //   ),
        //   onClick: () => {
        //     dispatch(setselectedTab("11.15"));
        //     dispatch(setHeadings("Upi Dmt Report"));
        //   },
        // },
      ],
    },
    {
      key: "101",
      icon: <FaCertificate />,
      label: <p>Download Certificate</p>,
      onClick: () => {
        dispatch(setselectedTab("101"));
        axios
          .get(
            APIURL +
              Globalendpoints.downLoadCertificate +
              `?primary_color=` +
              ThemeColor.primary.replace("#", "") +
              "&secondary_color=" +
              ThemeColor.primaryhover.replace("#", ""),
            {
              responseType: "blob",
              headers: {
                "Content-Type": "application/pdf",
                // Range: "bytes=0-999999",
                Authorization: `Bearer ${getLocalStorageItem("access_token")}`,
              },
            },
          )
          .then((res) => {
            saveAs(res.data, "file.pdf");
          })
          .catch((err) => console.log(err));
      },
    },
  ];
  if (profiledetail.member_type?.toLowerCase() !== "Retailer".toLowerCase()) {
    return list;
  } else {
    const filter = list.filter((i) => i.key !== "15" && i.key !== "44");
    return filter;
  }
};
